import { IMensagem } from "../../../Interfaces/HelpDesk/Equipes/Atendimento/AtendimentoInterfaces";
import { formatMessageTimeStamp } from "../../../Tools/FormatTools";

import "./styles.css";

interface IMensagensProps {
    mensagens: Array<IMensagem>;
    id?: string;
}

export default function Mensagens(props: IMensagensProps) {
    const mensagens = props.mensagens;
    return (
        <div className="messages" id={props.id}>
            {mensagens.map((mensagem, index) => {
                const mimeType = mensagem.MediaContentType0
                    ? mensagem.MediaContentType0.split("/")[0]
                    : undefined;
                return (
                    <div
                        key={index}
                        className={`d-flex flex-column mb-5 align-items-${mensagem.MensagemCliente ? "start" : "end"
                            }`}
                    >
                        <div className="d-flex align-items-center">
                            <span className="text-muted font-size-sm">
                                {formatMessageTimeStamp(
                                    mensagem.TimeStamp,
                                    true,
                                    mensagem.TimeStampSync
                                )}
                            </span>
                            {!mensagem.MensagemCliente && mensagem.DsUsuario && (
                                <span className="text-dark-75 text-hover-primary font-weight-bold font-size-h6 ml-5">
                                    {mensagem.DsUsuario}{" "}
                                    {mensagem.DsEquipe &&
                                        `(${mensagem.DsEquipe})`}
                                </span>
                            )}
                        </div>
                        <div
                            className={`mt-2 rounded p-5 bg-light-${mensagem.MensagemCliente ? "success" : "primary"
                                } text-dark-50 font-weight-bold font-size-lg text-left max-w-400px text-break`}
                        >
                            <div className="d-flex flex-column">
                                {mimeType &&
                                    (mimeType === "image" ||
                                        mimeType === "audio" ||
                                        mimeType === "video") ? (
                                    <>
                                        <div
                                            className="media"
                                            onClick={() => {
                                                window.open(
                                                    mensagem.MediaUrl0,
                                                    "devmedia",
                                                    "height=400,weight=400"
                                                );
                                            }}
                                        >
                                            {mimeType === "image" && mensagem.MediaUrl0 ? (
                                                <img
                                                    src={
                                                        mensagem.MediaUrl0.includes(".google.com/uc?id=") ?
                                                            mensagem.MediaUrl0.replace("https://docs.google.com/uc?id=",
                                                                "https://drive.google.com/thumbnail?id=") :
                                                            mensagem.MediaUrl0
                                                    }
                                                    loading="lazy"
                                                    alt="Imagem enviada via Whatsapp"
                                                    className="mb-2"
                                                />
                                            ) : mimeType === "audio" ? (
                                                <audio
                                                    controls
                                                    src={mensagem.MediaUrl0}
                                                ></audio>
                                            ) : (
                                                mimeType === "video" && (
                                                    <video
                                                        controls
                                                        src={mensagem.MediaUrl0}
                                                    ></video>
                                                )
                                            )}
                                        </div>
                                        {mensagem.Body}
                                    </>
                                ) : mimeType ? (
                                    <a
                                        href={
                                            mensagem.MediaUrl0 || mensagem.Body
                                        }
                                        target="__blank"
                                    >
                                        {mensagem.Body || "arquivo"}
                                    </a>
                                ) : (
                                    <div
                                        dangerouslySetInnerHTML={{
                                            __html: mensagem.Body.replace(
                                                /\n/g,
                                                "<br>"
                                            ),
                                        }}
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
}

export function MensagensPlaceHolder() {
    return (
        <div className="messages">
            <div className={`d-flex flex-column mb-5 align-items-start`}>
                <div className="d-flex align-items-center">
                    <span className="text-muted font-size-sm">
                        <div
                            className="placeholder-text"
                            style={{
                                width: "50px",
                                height: "10px",
                            }}
                        />
                    </span>
                </div>
                <div
                    className={`mt-2 rounded p-5 bg-gray-100 text-dark-50 font-weight-bold font-size-lg text-left max-w-400px text-break`}
                >
                    <div className="d-flex flex-column">
                        <div
                            className="placeholder-text"
                            style={{
                                width: "150px",
                                height: "10px",
                            }}
                        />
                        <div
                            className="placeholder-text"
                            style={{
                                width: "50px",
                                height: "10px",
                            }}
                        />
                        <div
                            className="placeholder-text"
                            style={{
                                width: "100px",
                                height: "10px",
                            }}
                        />
                    </div>
                </div>
            </div>

            <div className={`d-flex flex-column mb-5 align-items-end`}>
                <div className="d-flex align-items-center">
                    <span className="text-muted font-size-sm">
                        <div
                            className="placeholder-text"
                            style={{
                                width: "50px",
                                height: "10px",
                            }}
                        />
                    </span>
                </div>
                <div
                    className={`mt-2 rounded p-5 bg-gray-200 text-dark-50 font-weight-bold font-size-lg text-left max-w-400px text-break`}
                >
                    <div className="d-flex flex-column">
                        <div
                            className="placeholder-text"
                            style={{
                                width: "50px",
                                height: "10px",
                            }}
                        />
                        <div
                            className="placeholder-text"
                            style={{
                                width: "150px",
                                height: "10px",
                            }}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}
